import { useEffect, useState } from 'react';
import { getImmediateStorageUrl, resolveStorageUrl } from '@/lib/storage';

export function useStorageSignedUrl(value: string | null | undefined, bucket = 'post-media') {
  const [url, setUrl] = useState<string | null>(() => getImmediateStorageUrl(value ?? null, bucket));

  useEffect(() => {
    let active = true;
    const immediate = getImmediateStorageUrl(value ?? null, bucket);
    setUrl(immediate);

    if (!value) {
      return () => {
        active = false;
      };
    }

    resolveStorageUrl(value, bucket).then((resolved) => {
      if (active) setUrl(resolved);
    });

    return () => {
      active = false;
    };
  }, [value, bucket]);

  return url;
}
